import React from 'react';

import {
    Wrapper,
    Image,
    MainContent,
    Heading,
    Description
} from './HowMuchIsMyHomeWorth.styles';
import homeWorthSvgBVersion from 'public/assets/homepage/second-stepper-couple.png';

import homepageTranslations from 'public/locales/en/homepage.json';
import { getTranslator } from '../../../shared/i18n/getTranslator';
import { GetHomeWorthEstimateForm } from 'shared/components/GetHomeWorthEstimateForm/GetHomeWorthEstimateForm';

const t = getTranslator(homepageTranslations);

const headlineText = t('home_worth.headline');
const descriptionText = t('home_worth.description');

const homeWorthSvgDimensions = { width: 589, height: 331 };

export const HowMuchIsMyHomeWorth = () => {
    return (
        <>
            <Wrapper>
                <Image
                    src={homeWorthSvgBVersion}
                    width={homeWorthSvgDimensions.width}
                    height={homeWorthSvgDimensions.height}
                    alt=""
                />
                <MainContent>
                    <Heading size="4">{headlineText}</Heading>
                    <Description>{descriptionText}</Description>
                    <GetHomeWorthEstimateForm eventCategory="homepage" />
                </MainContent>
            </Wrapper>
        </>
    );
};
